import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";

import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
import { useNotification } from "context/NotificationContext";

import Api from "utils/Api";
import TrataRetornoApi from "utils/TrataRetornoApi";

const ListarPainelIndicadores = () => {
  const { setLoading } = useLoading();
  const notificacao = useNotification();
  const auth = useAuth();
  const requisicao = new Api();
  const tratarRetornoApi = new TrataRetornoApi();

  const jaExecutouRef = useRef(false);

  // estados
  const [dadosNotasPendentes, setDadosNotasPendentes] = useState([]);
  const [totalNotasPendentes, setTotalNotasPendentes] = useState(0);
  const [ehOperador, setEhOperador] = useState(true);
  const [dadosUltimoSincronismo, setDadosUltimoSincronismo] = useState([]);
  const [modalDetalhes, setModalDetalhes] = useState(false);
  const [detalhesVenda, setDetalhesVenda] = useState([]);
  const [semSerie, setSemSerie] = useState({
    semSerieNfeEntrada: [],
    semSerieNfeSaida: [],
    semSerieNfeEntradaSaida: []
  });
  const [filiaisSemNumeroSerieNfce, setFiliaisSemNumeroSerieNfce] = useState(
    []
  );
  const [qtdeErroLogErroInterno, setQtdeErroLogErroInterno] = useState(0);
  const [qtdeUsuariosSenhasDuplicados, setQtdeUsuariosSenhasDuplicados] =
    useState(0);

  // toggles
  const [showPendentes, setShowPendentes] = useState(false);
  const [showSincronismo, setShowSincronismo] = useState(false);
  const [showEntrada, setShowEntrada] = useState(false);
  const [showSaida, setShowSaida] = useState(false);
  const [showEntradaSaida, setShowEntradaSaida] = useState(false);
  const [showSemSerieNfce, setShowSemSerieNfce] = useState(false);

  // colunas das tabelas
  const colunasNotasPendentes = [
    { field: "operadorNome", header: "Operador" },
    { field: "lojaCodigo", header: "Loja" },
    { field: "balcaoNome", header: "Nome do Balcão" },
    { field: "balcaoCnpj", header: "CNPJ do Balcão" },
    { field: "quantidade", header: "Qtde" }
  ];
  const colunasUltimoSincronismo = [
    { field: "operadorNome", header: "Operador" },
    { field: "lojaCodigo", header: "Loja" },
    { field: "balcaoNome", header: "Nome do Balcão" },
    { field: "balcaoCnpj", header: "CNPJ do Balcão" },
    { field: "ultimaSincronizacao", header: "Última Sincronização" }
  ];
  const colunasSemSerie = [
    { field: "operador", header: "Operador" },
    { field: "cnpjBalcao", header: "CNPJ do Balcão" }
  ];
  const colunasFiliaisSemSerie = [
    { field: "cnpj", header: "CNPJ" },
    { field: "lojaId", header: "Loja ID" },
    { field: "balcaoId", header: "Balcão ID" }
  ];

  // helpers de estilo
  const getNumericColor = (value) => (value > 0 ? "red" : "green");
  const getBorderStyle = (value) => `2px solid ${value > 0 ? "red" : "green"}`;

  const baseCardStyle = {
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: "1rem"
  };

  const formatarData = (dateString) =>
    dateString ? new Date(dateString).toLocaleString("pt-BR") : "";

  const carregarIndicadores = async () => {
    try {
      setLoading(true);
      const resposta = await requisicao.Get({
        endpoint: "/PainelIndicadores",
        config: auth.GetHeaders()
      });

      if (resposta?.codigoEstadoHttp === 200) {
        const notas = resposta.objetoResposta.notasPendenteEmissaoPorLoja || [];
        setDadosNotasPendentes(notas);
        setTotalNotasPendentes(
          notas.reduce((soma, item) => soma + (item.quantidade || 0), 0)
        );
        setDadosUltimoSincronismo(
          resposta.objetoResposta.ultimosLogsSincronismoPorLoja || []
        );

        const devol =
          resposta.objetoResposta?.cnpjsBalcoesSemSerieNfeDevolucao || {};

        setSemSerie({
          semSerieNfeEntrada: devol.semSerieNfeEntrada || [],
          semSerieNfeSaida: devol.semSerieNfeSaida || [],
          semSerieNfeEntradaSaida: devol.semSerieNfeEntradaSaida || []
        });
        setFiliaisSemNumeroSerieNfce(
          resposta.objetoResposta?.filiaisSemNumeroSerieNfce || []
        );
        setQtdeErroLogErroInterno(
          resposta.objetoResposta?.qtdeErroLogErroInterno || 0
        );
        setQtdeUsuariosSenhasDuplicados(
          resposta.objetoResposta?.qtdeUsuariosSenhasDuplicados || 0
        );

        const ehOperadorAux = resposta.objetoResposta?.ehOperador;

        console.log("ehOperadorAux", ehOperadorAux);

        setEhOperador(ehOperadorAux);
      } else {
        notificacao({
          type: "erro",
          message: tratarRetornoApi.obterMensagemErro(resposta)
        });
      }
    } catch (error) {
      notificacao({
        type: "erro",
        message: tratarRetornoApi.obterMensagemErro(error)
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!jaExecutouRef.current) {
      jaExecutouRef.current = true;
      carregarIndicadores();
    }
  }, []);

  const abrirModalDetalhes = (vendasPendentes) => {
    setDetalhesVenda(vendasPendentes || []);
    setModalDetalhes(true);
  };

  const exibirDetalhesTemplate = (rowData) => (
    <Button
      icon="pi pi-search"
      className="p-button-text"
      onClick={() => abrirModalDetalhes(rowData.vendasComNotasPendentes)}
      disabled={!rowData.vendasComNotasPendentes?.length}
    />
  );

  return (
    <div className="p-grid">
      {/* Notas Pendentes */}
      <div className="p-col-12">
        <Card
          style={{
            ...baseCardStyle,
            border: getBorderStyle(totalNotasPendentes)
          }}
        >
          <div
            role="button"
            tabIndex={0}
            onClick={() => setShowPendentes((v) => !v)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setShowPendentes((v) => !v);
              }
            }}
            style={{
              textAlign: "center",
              cursor: "pointer",
              padding: "1.5rem"
            }}
          >
            <h3 style={{ fontWeight: 600 }}>
              Notas Fiscais Pendentes de Emissão
            </h3>
            <p
              style={{
                fontSize: "2rem",
                margin: 0,
                fontWeight: 700,
                color: getNumericColor(totalNotasPendentes)
              }}
            >
              {totalNotasPendentes}
              <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                {" "}
                notas pendentes
              </span>
            </p>
            <p style={{ fontSize: "1rem", marginTop: "0.3rem", color: "#666" }}>
              em {dadosNotasPendentes.length} balcões
            </p>
          </div>
          {showPendentes && (
            <div
              style={{
                padding: "1rem",
                backgroundColor: "#f9f9f9",
                borderTop: "1px solid #eee",
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px"
              }}
            >
              <DataTable
                value={dadosNotasPendentes}
                paginator
                rows={10}
                tableStyle={{ minWidth: "60rem" }}
                emptyMessage="Nenhum dado encontrado."
              >
                {colunasNotasPendentes.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    sortable
                  />
                ))}
                <Column
                  header="Ações"
                  body={exibirDetalhesTemplate}
                  style={{ textAlign: "center" }}
                />
              </DataTable>
            </div>
          )}
        </Card>
      </div>

      {!ehOperador && (
        <>
          {/* Sincronismo */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(dadosUltimoSincronismo.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSincronismo((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowSincronismo((v) => !v);
                  }
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>Último Sincronismo &gt; 24h</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(dadosUltimoSincronismo.length)
                  }}
                >
                  {dadosUltimoSincronismo.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showSincronismo && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={dadosUltimoSincronismo}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "60rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasUltimoSincronismo.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* Balcões sem Série NFCe */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(filiaisSemNumeroSerieNfce.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSemSerieNfce((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowSemSerieNfce((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>Balcões sem Série NFCe</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(filiaisSemNumeroSerieNfce.length)
                  }}
                >
                  {filiaisSemNumeroSerieNfce.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showSemSerieNfce && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={filiaisSemNumeroSerieNfce}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasFiliaisSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série Entrada e Saída */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeEntradaSaida.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowEntradaSaida((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowEntradaSaida((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>
                  CNPJs sem Série Entrada e Saída
                </h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(
                      semSerie.semSerieNfeEntradaSaida.length
                    )
                  }}
                >
                  {semSerie.semSerieNfeEntradaSaida.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showEntradaSaida && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeEntradaSaida}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série NFe Entrada */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeEntrada.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowEntrada((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowEntrada((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>CNPJs sem Série NFe Entrada</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(semSerie.semSerieNfeEntrada.length)
                  }}
                >
                  {semSerie.semSerieNfeEntrada.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showEntrada && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeEntrada}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série NFe Saída */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeSaida.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSaida((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowSaida((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>CNPJs sem Série NFe Saída</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(semSerie.semSerieNfeSaida.length)
                  }}
                >
                  {semSerie.semSerieNfeSaida.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showSaida && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeSaida}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* Log Erros Internos */}
          <div className="p-col-12 p-md-6">
            <Card
              style={{
                ...baseCardStyle,
                textAlign: "center",
                padding: "1rem",
                border: getBorderStyle(qtdeErroLogErroInterno)
              }}
            >
              <h3 style={{ fontWeight: 600 }}>Log de Erros Internos</h3>
              <p
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: getNumericColor(qtdeErroLogErroInterno)
                }}
              >
                {qtdeErroLogErroInterno}
              </p>
            </Card>
          </div>

          {/* Usuários com Senha Duplicada */}
          <div className="p-col-12 p-md-6">
            <Card
              style={{
                ...baseCardStyle,
                textAlign: "center",
                padding: "1rem",
                border: getBorderStyle(qtdeUsuariosSenhasDuplicados)
              }}
            >
              <h3 style={{ fontWeight: 600 }}>Usuários com Senha Duplicada</h3>
              <p
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: getNumericColor(qtdeUsuariosSenhasDuplicados)
                }}
              >
                {qtdeUsuariosSenhasDuplicados}
              </p>
            </Card>
          </div>
        </>
      )}

      {/* Modal de detalhes */}
      <Dialog
        header="Vendas com Notas Pendentes"
        visible={modalDetalhes}
        style={{ width: "40vw" }}
        onHide={() => setModalDetalhes(false)}
      >
        {detalhesVenda.length > 0 ? (
          <ul>
            {detalhesVenda.map((v) => (
              <li key={v.id}>
                <strong>Venda:</strong> {v.numero} <br />
                <strong>Data:</strong> {formatarData(v.dataVenda)}
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhuma venda encontrada.</p>
        )}
      </Dialog>
    </div>
  );
};

export default ListarPainelIndicadores;
